<svg
  class="ui-icon ui-icon--{{ size() }}"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  focusable="false"
>
  @for (path of paths; track $index) {
    <path [attr.d]="path" />
  }
</svg>
